module.exports = __webpack_public_path__ + "static/media/SC.550f2691.png";